export default defineNuxtRouteMiddleware((_to, _from) => {
  const auth = useAuth()
  if (['retainingAccountInfo', 'loggedOut'].includes(auth.accountStatus)) return

  return navigateTo({ path: '/dashboard' })
})
